import { IOfferCard } from '../../../types';
import { getAgentBonusPrice } from './getAgentBonusPrice';
import { getDepositPrice } from './getDepositPrice';
import { getFeePrice } from './getFeePrice';
import { getLeasePeriod } from './getLeasePeriod';
import { getUtilitiesTermsPrice } from './getUtilitiesTermsPrice';

export function getRentPriceInfo(offerCard: IOfferCard, isAgent: boolean): string | undefined {
  const infoParts = [
    getLeasePeriod(offerCard),
    getUtilitiesTermsPrice(offerCard),
    getFeePrice(offerCard, isAgent),
    getDepositPrice(offerCard),
    getAgentBonusPrice(offerCard, isAgent),
  ].filter(Boolean);

  if (offerCard.dailyrent?.hotelData?.isHotel) {
    return offerCard.dailyrent.hotelData.priceSubtitle;
  }

  if (infoParts.length > 0) {
    const res = infoParts.join(', ');

    return `${res[0].toUpperCase()}${res.slice(1)}`;
  }

  return undefined;
}
